import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Login = () => {
  const [tab,      setTab]      = useState('admin');
  const [email,    setEmail]    = useState('');
  const [id,       setId]       = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (isAuthenticated) navigate('/');
  }, [isAuthenticated, navigate]);

  const handleSubmit = async e => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const success = tab === 'superadmin'
        ? await login({ id, password }, true)
        : await login({ email, password }, false);
      if (!success) setError('Invalid credentials. Please try again.');
    } catch {
      setError('Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-brand">
          <div className="login-brand-logo">
            <i className="fas fa-shopping-basket" />
          </div>
          <h2>Quick <span>Grocery</span></h2>
          <p>Admin Panel</p>
        </div>

        <div className="login-tabs">
          <button className={`login-tab${tab === 'admin' ? ' on' : ''}`} type="button" onClick={() => setTab('admin')}>Admin</button>
          <button className={`login-tab${tab === 'superadmin' ? ' on' : ''}`} type="button" onClick={() => setTab('superadmin')}>Super Admin</button>
        </div>

        {error && <div className="login-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          {tab === 'admin' ? (
            <div className="form-group">
              <label className="form-label">Email address</label>
              <input className="form-control" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="admin@example.com" required />
            </div>
          ) : (
            <div className="form-group">
              <label className="form-label">Admin ID</label>
              <input className="form-control" type="text" value={id} onChange={e => setId(e.target.value)} placeholder="Enter your ID" required />
            </div>
          )}
          <div className="form-group">
            <label className="form-label">Password</label>
            <input className="form-control" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required />
          </div>
          <button type="submit" className="btn btn-primary login-btn" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
